// src/pages/ClientData/index.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ClientData.css';
import { useClientDataSearch } from './hooks/useClientDataSearch';
import { maskClientCode, maskProcessCode } from './utils/masks';
import SearchHeader from './components/SearchHeader';
import ClientDataSection from './components/ClientDataSection';
import ProcessesSection from './components/ProcessesSection';
import BulkLoadDialog from './components/BulkLoadDialog';
import ClientMatchesDialog from './components/ClientMatchesDialog';

const ClientData = () => {
  const navigate = useNavigate();
  const {
    clientCodeInput,
    setClientCodeInput,
    processCodeInput,
    setProcessCodeInput,
    searching,
    searchError,
    hasSearched,
    hasResults,
    search,

    nameSearchInput,
    setNameSearchInput,
    nameSearching,
    nameSearchError,
    searchByName,
    clientMatches,
    selectClientMatch,
    closeClientMatches,

    clientData,

    processes,
    processDetails,
    processDetailLoading,
    processDetailErrors,
    loadProcessDetail,

    movements,
    movementsLoading,
    movementsErrors,
    loadMovements,

    movementFiles,
    movementFilesLoading,
    movementFilesErrors,
    loadMovementFiles,

    fileTranscriptions,
    fileTranscriptionLoading,
    fileTranscriptionErrors,
    fileSaving,
    setFileTranscriptionText,
    transcreverFicheiro,
    salvarFicheiroComoDocumento,

    loadAllMovements,
    setLoadAllMovements,
    loadAllFiles,
    setLoadAllFiles,
    bulkProgress,
    closeBulkProgress,

    fullContent,
    saving,
    saveToMeusDocumentos
  } = useClientDataSearch();

  const handleChatComIA = () => {
    if (!fullContent.trim()) return;
    navigate('/chat-with-ai', {
      state: {
        content: fullContent,
        origin: 'client-data',
        originTitle: 'Dados do Cliente'
      }
    });
  };

  const handleSaveDocument = async () => {
    const resultado = await saveToMeusDocumentos();
    if (resultado.success) {
      alert('Documento guardado em Meus Documentos!');
    } else {
      alert(resultado.message || 'Erro ao guardar documento');
    }
  };

  return (
    <div className="client-data-container">
      <div className="client-data-header">
        <h2>👤 Dados do Cliente</h2>
        <p>Consulte informações detalhadas de clientes, processos e movimentos</p>
      </div>

      <div className="client-data-content">
        <SearchHeader
          clientCodeInput={clientCodeInput}
          processCodeInput={processCodeInput}
          onClientCodeChange={(value) => setClientCodeInput(maskClientCode(value))}
          onProcessCodeChange={(value) => setProcessCodeInput(maskProcessCode(value))}
          nameSearchInput={nameSearchInput}
          onNameSearchChange={setNameSearchInput}
          onSearchByName={searchByName}
          nameSearching={nameSearching}
          nameSearchError={nameSearchError}
          onSearch={search}
          searching={searching}
          error={searchError}
          hasResults={hasResults}
          onChatComIA={handleChatComIA}
          onSaveDocument={handleSaveDocument}
          saving={saving}
          loadAllMovements={loadAllMovements}
          onLoadAllMovementsChange={setLoadAllMovements}
          loadAllFiles={loadAllFiles}
          onLoadAllFilesChange={setLoadAllFiles}
        />

        {searching && (
          <div className="loading-data">
            <span>⏳</span>
            <span>A pesquisar dados...</span>
          </div>
        )}

        {!searching && hasSearched && !hasResults && !searchError && (
          <div className="error-message">Não foram encontrados dados para o código indicado</div>
        )}

        {!searching && hasResults && (
          <>
            <ClientDataSection clientData={clientData} />

            <ProcessesSection
              processes={processes}
              processDetails={processDetails}
              processDetailLoading={processDetailLoading}
              processDetailErrors={processDetailErrors}
              onLoadDetail={loadProcessDetail}
              movements={movements}
              movementsLoading={movementsLoading}
              movementsErrors={movementsErrors}
              onLoadMovements={loadMovements}
              movementFiles={movementFiles}
              movementFilesLoading={movementFilesLoading}
              movementFilesErrors={movementFilesErrors}
              onLoadFiles={loadMovementFiles}
              fileTranscriptions={fileTranscriptions}
              fileTranscriptionLoading={fileTranscriptionLoading}
              fileTranscriptionErrors={fileTranscriptionErrors}
              fileSaving={fileSaving}
              onSetFileTranscriptionText={setFileTranscriptionText}
              onTranscreverFicheiro={transcreverFicheiro}
              onSalvarFicheiro={salvarFicheiroComoDocumento}
            />
          </>
        )}
      </div>

      <ClientMatchesDialog
        matches={clientMatches}
        onSelect={selectClientMatch}
        onClose={closeClientMatches}
      />

      <BulkLoadDialog progress={bulkProgress} onClose={closeBulkProgress} />
    </div>
  );
};

export default ClientData;
